import { gql } from '@apollo/client';

/**
 * GraphQL mutation to update a standard label
 */
export const UPDATE_STANDARD_LABEL = gql`
  mutation UpdateStandardLabel($id: ID!, $input: UpdateStandardLabelInput!) {
    updateStandardLabel(id: $id, input: $input) {
      label {
        id
        labelName
        labelShortName
        policy
        contentType
        labelStatus
        labelNumMap
        scope {
          global
          communities
          communityGroups
        }
        createdBy
        createdAt
        lastModifiedBy
        lastModifiedAt
      }
    }
  }
`;
